import { Component, OnInit } from "@angular/core";
import {
  NavController,
  NavParams,
  ModalController,
  LoadingController,
  AlertController,
  IonicModule,
} from "@ionic/angular";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { EventoProvider } from "src/app/services/evento/evento";
import { UserProvider } from "src/app/services/user/user";
import { format } from "date-fns";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { LoadingSpinnerComponent } from "src/app/components/loading/loading-spinner/loading-spinner.component";

@Component({
  selector: "app-servicos-inscricao",
  templateUrl: "./servicos-inscricao.page.html",
  styleUrls: ["./servicos-inscricao.page.scss"],
  standalone: true,
  imports: [CommonModule, FormsModule, IonicModule, TranslateModule, LoadingSpinnerComponent],
})
export class ServicosInscricaoPage implements OnInit {
  idInscricao: any;
  isAvulso: any = false;
  loaded = false;
  loading: any = false;
  hideBtn: any = false;
  servicos: any = [];
  idPresenca: any;
  qntLotes: any = [];
  qntChecks: any;
  qntLotesTotal: any;
  checkInsRealizados: any;
  lotes: any;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public modalCtrl: ModalController,
    public loadingController: LoadingController,
    public translate: TranslateService,
    public alertCtrl: AlertController,
    public eventoProvider: EventoProvider,
    public userProvider: UserProvider
  ) {
    this.idInscricao = this.navParams.get("idInscricao");
    this.isAvulso = this.navParams.get("isAvulso");
    this.idPresenca = this.navParams.get("idPresenca");
  }

  ngOnInit() {
    this.buscar();
  }

  buscar() {
    if (this.idPresenca) {
      this.eventoProvider.getDetalhesPresenca(this.idInscricao, this.idPresenca).subscribe((data) => {
        this.qntLotes = new Array(data.qntLotes);
        this.qntLotesTotal = data.qntLotesTotal;
        this.checkInsRealizados = data.checkInsRealizados * 1 + 1;
        this.lotes = data.lotes;
        this.servicos = data.servicos;
        this.trataServicos();
      });
    } else {
      this.eventoProvider.getServicosByIdInscricao(this.idInscricao).subscribe((data) => {
        this.servicos = data;
        this.trataServicos();
      });
    }

    setTimeout(() => {
      this.loaded = true;
    }, 1000);
  }

  trataServicos() {
    const servicos = this.servicos.filter((filter: { data_retirada: any }) => filter.data_retirada);
    if (servicos.length == this.servicos.length) this.hideBtn = true;
  }

  confirmarCheck() {
    if (this.qntChecks && this.qntChecks >= 1) {
      this.eventoProvider.checkInAvulso(this.idPresenca, this.qntChecks).subscribe(async (data) => {
        if (data) {
          let alert = await this.alertCtrl.create({
            cssClass: "alerta-personalizado",
            mode: "ios",
            header: this.translate.instant("Sucesso!"),
            message: this.translate.instant("Foram feitos ") + this.qntChecks + this.translate.instant( " check-ins"),
            buttons: [
              {
                text: this.translate.instant("Ok"),
                handler: () => {
                  this.qntChecks = null;
                  this.buscar();
                },
              },
            ],
          });

          alert.present();
        } else {
          let alert = await this.alertCtrl.create({
            cssClass: "alerta-personalizado",
            mode: "ios",
            header: this.translate.instant("Erro"),
            message: this.translate.instant("Houve um erro ao tentar salvar check-in"),
            buttons: [
              {
                text: this.translate.instant("Ok"),
                handler: () => {},
              },
            ],
          });

          alert.present();
        }
      });
    }
  }

  retirarServico(servico: { data_retirada: string; id: any }) {
    if (!servico.data_retirada) {
      servico.data_retirada = format(new Date(), "yyyy-MM-dd HH:mm:ss");
      this.eventoProvider.retirarServico(servico.id).subscribe((data) => {
        this.trataServicos();
      });
    }
  }

  async retirarTodosServicos() {
    let alert = await this.alertCtrl.create({
      cssClass: "alerta-personalizado",
      mode: "ios",
      header: this.translate.instant("Atenção"),
      message: this.translate.instant("Deseja retirar todos os serviços?"),
      buttons: [
        {
          text: this.translate.instant("Não"),
          handler: () => {},
        },
        {
          text: this.translate.instant("Sim"),
          handler: () => {
            this.eventoProvider.retirarTodosServicos(this.idInscricao).subscribe((data) => {
              this.buscar();
            });
          },
        },
      ],
    });
    alert.present();
  }

  public closeModal() {
    this.modalCtrl.dismiss();
  }
}
